//essentials
import PropTypes from 'prop-types';

import ReactDOMServer from 'react-dom/server';

import React, {
    useContext,
    useRef,
} from 'react';

import L from 'leaflet';
import MarkerClusterGroup from 'react-leaflet-cluster';
import { Marker, useMap, Popup } from 'react-leaflet';

//components
import { LocationContext } from '../LocationContext/LocationContext';
import CustomMarker from '../CustomMarker/CustomMarker';
import DefaultIcon from '../../assets/images/icons/DefaultIcon';

//styles
import styles from './LocationMap.module.scss';


const ClusteredMarkers = ({ markerClick }) => {
    const clusterGroupRef = useRef(null);
    const map = useMap();
    const {
        locationObjects,
    } = useContext(LocationContext);

    const handleClusterMouseOver = (event) => {
        const cluster = event.layer;
        const center = cluster.getLatLng();

        const clusteredMarkers = cluster.getAllChildMarkers().map((marker) => {

            return marker.options.marker;
        });

        // add a link from ne new Function like markerAction()
        const clusteredMarkersListDOM = clusteredMarkers.map((marker) => {

            return <li key={marker}>{marker.name}</li>;
        });

        L.popup()
            .setLatLng(center)
            .setContent(`<div><ul>${ReactDOMServer.renderToString(clusteredMarkersListDOM)}</ul></div>`)
            .openOn(map);
    };

    // Add a mouseout event listener to show all cluster icons again
    const handleClusterMouseOut = (event) => {
        const cluster = event.layer;
        const center = cluster.getLatLng();

        L.popup()
            .setLatLng(center)
            .openOn(map)
            .close();

        // Show all cluster icons again
        clusterGroupRef.current.getLayers().forEach((otherCluster) => {
            otherCluster.setOpacity(1);
        });
    };

    const markerDom = locationObjects?.map((marker) => {
        const {
            id,
            categoryId,
            lat,
            lon,
            name,
        } = marker;

        const markerAction = () => markerClick({
            // name,
            locationLat: lat,
            locationLon: lon,
            locationId: id,
        });

        return (
            <Marker
                key={id}
                eventHandlers={{
                    click: markerAction,
                    keydown: (event) => event.originalEvent.key === 'Enter' && markerAction(),
                    mouseover: (event) => {
                        event.target.openPopup();
                    },
                    mouseout: (event) => event.target.closePopup(),
                }}
                position={[lat, lon]}
                icon={L.divIcon({
                    className: styles.customMarker,
                    html: ReactDOMServer.renderToString(
                        <CustomMarker
                            title={name}
                            locationCategory={categoryId}
                        >
                            <DefaultIcon />
                        </CustomMarker>,
                    ),
                })}
                marker={marker}
            >
                <Popup>
                    <div className={styles.title}>{name}</div>
                </Popup>
            </Marker>
        );
    });

    return (
        <MarkerClusterGroup
            ref={clusterGroupRef}
            chunkedLoading
            spiderfyOnMaxZoom={true}
            spiderfyDistanceMultiplier={2}
            showCoverageOnHover={false}
            iconCreateFunction={(cluster) => {
                return L.divIcon({
                    html: `<div>
              <div>
                  <span>${cluster.getChildCount()}</span>
              </div>
             
          </div>`,
                    className: styles.customMarkerCluster,
                    iconSize: L.point(33, 33, true),
                });
            }}
            onMouseOver={handleClusterMouseOver}
            onMouseOut={handleClusterMouseOut}
        >
            {markerDom}
        </MarkerClusterGroup>
    );
};

ClusteredMarkers.propTypes = {
    markerClick: PropTypes.func,
};

export default ClusteredMarkers;
